import { render, staticRenderFns } from "./p16.vue?vue&type=template&id=2c7ef28e&scoped=true&"
import script from "./p16.vue?vue&type=script&lang=js&"
export * from "./p16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ef28e",
  null
  
)

export default component.exports